import ListItem from "../../../../__snowpack__/pkg/@mui/material/ListItem.js";
import ListItemButton from "../../../../__snowpack__/pkg/@mui/material/ListItemButton.js";
import ListItemIcon from "../../../../__snowpack__/pkg/@mui/material/ListItemIcon.js";
import ListItemText from "../../../../__snowpack__/pkg/@mui/material/ListItemText.js";
import {makeStyles} from "../../../../__snowpack__/pkg/@mui/styles.js";
import React, {useCallback, useEffect, useMemo} from "react";
import {getRandomString} from "../../../common/generic-react.functions.js";
import Radio from "../../atoms/radio/radio.component.js";
import {RadioListContainer} from "./radio-list.styles.js";
import {useFormikContext} from "../../../../__snowpack__/pkg/formik.js";
const useStyles = makeStyles({
  flex_col1: {
    flex: "1 1 100%",
    maxWidth: "70%",
    "& ~ div.MuiListItemSecondaryAction-root": {
      maxWidth: "30%",
      flex: "1 1 100%",
      display: "flex",
      position: "relative",
      top: "inherit",
      transform: "none",
      textAlign: "right"
    }
  },
  flex_row: {
    flexDirection: "row"
  },
  min_Width: {
    minWidth: "auto"
  },
  word_break: {
    "& :nth-child(1)": {
      wordBreak: "break-all"
    }
  }
});
function RadioList({
  items,
  name,
  onChange,
  reset
}) {
  const classes = useStyles();
  const itemName = useMemo(() => name || getRandomString(), [name]);
  const {
    setFieldValue,
    values
  } = useFormikContext();
  const handleChange = useCallback((value) => {
    if ("disabled" in value && !value.disabled && onChange) {
      onChange(value);
    }
  }, [onChange]);
  useEffect(() => {
    if (reset) {
      const keys = Object.keys(values);
      if (keys.length > 0) {
        setFieldValue(keys[0], "");
      }
    }
  }, [reset]);
  return /* @__PURE__ */ React.createElement(RadioListContainer, null, items.map((item) => {
    return /* @__PURE__ */ React.createElement(ListItem, {
      className: classes.flex_row,
      key: item.id.toString(),
      disablePadding: true,
      disabled: item.disabled,
      secondaryAction: /* @__PURE__ */ React.createElement(ListItemText, {
        className: classes.word_break,
        primary: item.rightText
      })
    }, /* @__PURE__ */ React.createElement(ListItemButton, {
      dense: true,
      className: classes.flex_col1
    }, /* @__PURE__ */ React.createElement(ListItemIcon, {
      className: classes.min_Width
    }, /* @__PURE__ */ React.createElement(Radio, {
      name: itemName,
      value: item.id.toString(),
      disabled: item.disabled,
      onChange: () => handleChange(item)
    })), /* @__PURE__ */ React.createElement(ListItemText, {
      className: classes.word_break,
      primary: item.leftText
    })));
  }));
}
export default /* @__PURE__ */ React.memo(RadioList);
